import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isClientPortalUser } from '../lib/permissions';

/**
 * ISSUE-143: sólo el rol Cliente (RR.HH.) entra a `/portal/*`. Cualquier
 * usuario interno que intente navegar acá es redirigido a `/` — espejo del
 * lado del cliente de `InternalRoute` (que redirige a `/portal` en sentido
 * contrario).
 */
export function ClientPortalRoute() {
  const { user } = useAuth();
  return isClientPortalUser(user) ? <Outlet /> : <Navigate to="/" replace />;
}
